import { useEffect, useRef } from 'react';
import { trackScrollDepth } from '@/lib/analytics';

type Milestone = 25 | 50 | 75 | 100;
const MILESTONES: Milestone[] = [25, 50, 75, 100];

/**
 * Fires scroll_depth analytics events at 25/50/75/100% milestones.
 * Each milestone fires at most once per page view.
 */
export function useScrollDepth(pageType: string, pageId: string): void {
  const firedRef = useRef<Set<Milestone>>(new Set());

  useEffect(() => {
    const fired = firedRef.current;
    fired.clear();

    function onScroll() {
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      if (docHeight <= 0) return;

      const pct = (scrollTop / docHeight) * 100;

      for (const m of MILESTONES) {
        if (pct >= m && !fired.has(m)) {
          fired.add(m);
          trackScrollDepth(pageType, pageId, m);
        }
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [pageType, pageId]);
}
